<template>
  <div v-if="message" class="status-message alert" :class="'alert-' + messageType" v-html="message" v-on:click.prevent="executeCallback()"></div>
</template>

<style scoped>
.status-message {
  cursor: pointer;
}
</style>

<script>
export default {
  data() {
    return {
      message: null,
      messageType: null,
      callback: null
    }
  },
  methods: {
    clear() {
      this.message = null;
      this.messageType = null;
    },
    error(message, callback=null) {
      this.set('danger', message, callback);
    },
    set(type, message, callback) {
      this.message = message;
      this.callback = callback;
      this.messageType = type;
    },
    executeCallback() {
      if (this.callback) {
        this.callback();
      }
    }
  }
}
</script>